function normalizeFlag(value, fallback = false) {
  if (typeof value === 'boolean') return value;
  if (value == null) return fallback;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return fallback;
  if (['1', 'true', 'yes', 'on', 'enabled'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off', 'disabled'].includes(normalized)) return false;
  return fallback;
}

const FLAG_ENV = {
  ff_outcome_loop_v1: process.env.REACT_APP_FF_OUTCOME_LOOP_V1,
  ff_consent_execute_v1: process.env.REACT_APP_FF_CONSENT_EXECUTE_V1,
  ff_continuity_proof_v1: process.env.REACT_APP_FF_CONTINUITY_PROOF_V1,
  ff_journey_e2e_test_mode: process.env.REACT_APP_FF_JOURNEY_E2E_TEST_MODE
};

export function isFeatureEnabled(flagName, fallback = false) {
  const key = String(flagName || '').trim().toLowerCase();
  const envValue = FLAG_ENV[key];
  const envEnabled = normalizeFlag(envValue, fallback);

  try {
    const override = localStorage.getItem(`ff:${key}`);
    if (override != null) {
      return normalizeFlag(override, envEnabled);
    }
  } catch (error) {
    // localStorage may be unavailable in some contexts
  }

  return envEnabled;
}

export const featureFlags = {
  outcomeLoopV1: isFeatureEnabled('ff_outcome_loop_v1', true),
  consentExecuteV1: isFeatureEnabled('ff_consent_execute_v1', false),
  continuityProofV1: isFeatureEnabled('ff_continuity_proof_v1', false),
  journeyE2ETestMode: isFeatureEnabled('ff_journey_e2e_test_mode', false)
};

export default featureFlags;
